import AdminLoginModal from '../components/Blog/AdminLoginModal';
import AdminBlogEditor from '../components/Blog/AdminBlogEditor';
import BlogMainPage from '../components/Blog/BlogMainPage';
import BlogDetail from '../components/Blog/BlogDetail';   // ✅ add this

const BlogRoutes = [
  { path: '/admin/login', element: <AdminLoginModal /> },
  { path: '/admin/blog/editor', element: <AdminBlogEditor /> },
  { path: '/blog', element: <BlogMainPage /> },
  { path: '/blog/:postId', element: <BlogDetail /> },     // ✅ detail route
];

export default BlogRoutes;
